
import { useEffect } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import Partnership from './components/Partnership';
// import LocationMap from './components/LocationMap';

export default function ContactPage() {
  useEffect(() => {
    // 设置页面标题和meta信息
    document.title = '联系我们 - 马帮瑞贡官网';
    
    // 更新meta描述
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '联系马帮瑞贡，获取更多普洱茶产品信息和合作机会。我们期待与您共同传承茶马古道文化，分享地道普洱好茶。');
    }

    // 更新meta关键词
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '马帮瑞贡,联系我们,普洱茶咨询,商务合作,茶叶批发,客户服务');
    }

    // 添加Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "联系我们 - 马帮瑞贡官网",
      "description": "联系马帮瑞贡，获取更多普洱茶产品信息和合作机会。我们期待与您共同传承茶马古道文化，分享地道普洱好茶。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/contact`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "马帮瑞贡官网",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
      },
      "about": {
        "@type": "Organization",
        "name": "马帮瑞贡",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer service",
          "availableLanguage": "Chinese"
        }
      }
    });
    document.head.appendChild(script);

    return () => {
      // 清理
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      <Partnership />
      {/* <LocationMap /> */}
      <Footer />
    </div>
  );
}